import axios from 'axios';
import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
export const getLimits = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: '/account/getLimits',
        params: {
            brand: brand.id,
        },
    });
};
